/* ==========================================================================
   FUMO Support Pages — JavaScript
   FAQ accordion smooth animation
   ========================================================================== */

(function () {
  'use strict';

  /* --- FAQ Accordion Animation --- */
  function initFaqAccordion(container) {
    var details = container.querySelectorAll('details');
    if (!details.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    details.forEach(function (detail) {
      var summary = detail.querySelector('summary');
      var answer = detail.querySelector('.fumo-faq__answer');
      if (!summary || !answer) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (prefersReducedMotion) {
          detail.open = !detail.open;
          return;
        }

        if (detail.open) {
          // Closing
          var startHeight = answer.scrollHeight;
          answer.style.maxHeight = startHeight + 'px';
          answer.style.overflow = 'hidden';

          requestAnimationFrame(function () {
            answer.style.transition = 'max-height 300ms cubic-bezier(0.25, 0.1, 0.25, 1)';
            answer.style.maxHeight = '0px';
          });

          answer.addEventListener('transitionend', function onEnd() {
            answer.removeEventListener('transitionend', onEnd);
            detail.open = false;
            answer.style.maxHeight = '';
            answer.style.overflow = '';
            answer.style.transition = '';
          });
        } else {
          // Opening
          detail.open = true;
          var endHeight = answer.scrollHeight;
          answer.style.maxHeight = '0px';
          answer.style.overflow = 'hidden';

          requestAnimationFrame(function () {
            answer.style.transition = 'max-height 300ms cubic-bezier(0.25, 0.1, 0.25, 1)';
            answer.style.maxHeight = endHeight + 'px';
          });

          answer.addEventListener('transitionend', function onEnd() {
            answer.removeEventListener('transitionend', onEnd);
            answer.style.maxHeight = '';
            answer.style.overflow = '';
            answer.style.transition = '';
          });
        }
      });
    });
  }

  /* --- Init on DOM ready --- */
  function init() {
    document.querySelectorAll('.fumo-faq').forEach(initFaqAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
